import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 57 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5.996 20.057c.5-.003 1.986-.135 2.615 1.96.424 1.412 1.1 3.724 2.026 6.936h.378c.994-3.387 1.676-5.698 2.048-6.936.636-2.116 2.226-1.96 2.862-1.96h4.907v15.055H15.83V26.24h-.336l-2.788 8.872H8.945l-2.788-8.879H5.82v8.879h-5V20.057h5.175Zm22.017 0v8.879h.4l3.39-7.3c.659-1.454 2.062-1.579 2.062-1.579h4.84v15.055h-5.106v-8.879h-.4l-3.324 7.301c-.658 1.446-2.128 1.578-2.128 1.578h-4.84V20.057h5.106Zm28.338 7.154c-.712 1.99-2.948 3.416-5.424 3.416h-5.355v4.485h-4.855v-7.9h15.634ZM51.159 20.059H40.461c.255 3.351 3.181 6.22 6.21 6.22h10.016c.578-2.785-1.412-6.22-5.528-6.22Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mir"}) } }